import { AvatarFallback, CustomAvatar } from "@/components/ui/avatar"
import { getShortName } from "@/lib/get-short-name"
import { getAvatarColorByRole } from "@/modules/common/helpers/common-helper"
import { UserRole } from "@/types/__generated__/union-types"

type SofiaAvatarProps = {
  firstName?: string | null
  lastName?: string | null
  role?: UserRole | null
  size?: "xs" | "md"
}

const SofiaAvatar = (props: SofiaAvatarProps) => {
  const { firstName, lastName, role, size } = props

  const shortName = getShortName(firstName, lastName)

  return (
    <CustomAvatar size={size ?? "xs"} data-testid="custom-avatar">
      <AvatarFallback className={`${getAvatarColorByRole(role)} z-0`} data-testid="avatar-fallback">
        {shortName}
      </AvatarFallback>
    </CustomAvatar>
  )
}

export { SofiaAvatar }
